import EmojiField from '$tablet-app/src/app/components/EmojiField';
import shadows from '$tablet-app/src/app/theme/shadows';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useMemo } from 'react';
import styled from 'styled-components/native';

interface Props {
  emoji?: string;

  onChange?(emoji: string): void;

  backgroundColor?: string;
}

export const EmojiInputField = (props: Props) => {
  const style = useMemo(
    () => ({
      backgroundColor: props.backgroundColor,
    }),
    [props.backgroundColor]
  );

  return (
    <EmojiField onChange={props.onChange}>
      {({ show }) => (
        <EmojiInputWrapper onPress={show}>
          <EmojiWrapper style={style}>
            <Emoji>{props.emoji}</Emoji>
          </EmojiWrapper>
          <EmojiEditIconWrapper>
            <FontAwesomeIcon icon="pencil" size={14} color="white" />
          </EmojiEditIconWrapper>
        </EmojiInputWrapper>
      )}
    </EmojiField>
  );
};

const EmojiInputWrapper = styled.TouchableOpacity`
  background-color: white;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 80px;
`;

const Emoji = styled.Text`
  font-size: 30px;
`;

const EmojiWrapper = styled.View`
  height: 80px;
  width: 80px;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
`;

const EmojiEditIconWrapper = styled.View`
  position: absolute;
  top: -8px;
  right: -8px;
  height: 35px;
  width: 35px;
  border-radius: 12px;
  background-color: ${colors.primary[70]};
  justify-content: center;
  align-items: center;
  ${shadows.small}
`;
